<template>
  <div>
    <surgery-filters
      :name.sync="payload.name"
      :approved.sync="payload.approved"
      :active.sync="payload.active"
      @apply="getSurgeries(payload)"
      :action="selected.length > 0"
    />
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="0" outlined>
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title> <h4>Surgeries</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="surgeries"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :page.sync="pagination.page"
            :options.sync="pagination"
            :items-per-page.sync="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            @click:row="edit($event.id)"
            class="elevation-0 black--text"
          >
            <template v-slot:header.data-table-select="{ props, on }">
              <!-- COLOR Not working when props.indeterminate is true -->
              <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu offset-y bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn dark icon v-bind="attrs" v-on="on">
                    <v-icon class="gray--text">more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item link>
                    <v-list-item-title @click="edit(item.id)"
                      >Edit</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item link>
                    <v-list-item-title @click="deleteAndRefresh(item.id)"
                      >Delete</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:item.amount="{ item }">
              {{ parseInt(item.amount, 10).toFixed(2) }}
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Helpers from "@/mixins/helpers";
import SurgeryFilters from "./SurgeryFilter";
export default {
  components: {
    SurgeryFilters
  },
  mixins: [Helpers],
  data() {
    let vm = this;
    return {
      surgeryId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Phone",
          align: "left",
          value: "phone",
          sortable: false
        },
        {
          text: "Address",
          align: "left",
          sortable: false,
          value: "address"
        },
        {
          text: "APT NO",
          align: "left",
          value: "aptNo",
          sortable: false
        },
        {
          text: "State",
          align: "left",
          value: "state",
          sortable: false
        },
        {
          text: "Post Code",
          align: "left",
          value: "postcode",
          sortable: false
        },
        {
          text: "Country",
          align: "left",
          value: "country",
          sortable: false
        },
        {
          text: "City",
          align: "left",
          value: "city",
          sortable: false
        },
        {
          text: "surgeryType",
          align: "left",
          value: "Surgery Type"
        },
        { text: "", value: "action", align: "right" }
      ],
      payload: {
        from: 0,
        to: 10,
        name: " ",
        approved: null,
        active: null
      }
    };
  },
  computed: {
    surgeries() {
      return this.$store.state.surgeries.surgeries;
    },
    totalItems() {
      return this.$store.state.surgeries.totalSurgeries;
    }
  },
  created() {
    this.getSurgeries(this.payload);
  },
  methods: {
    getSurgeries(payLoad) {
      this.loading = true;
      this.$store
        .dispatch("surgeries/LOAD_SURGERIES", payLoad)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      this.payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage;
      this.payload.to =
        pagination.itemsPerPage === -1
          ? this.totalItems
          : pagination.itemsPerPage;
      this.getSurgeries(this.payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        this.getSurgeries(this.payload);
      }
    }
  }
};
</script>
